import { useState } from "react";

const KEY = "anthm.sidebar.favoritesCollapsed";

/** Whether the sidebar's pinned spaces are collapsed, remembered per device. */
export function useFavoritesCollapsed(): [boolean, (collapsed: boolean) => void] {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(KEY) === "true";
    } catch {
      return false;
    }
  });
  const save = (next: boolean) => {
    setCollapsed(next);
    try {
      localStorage.setItem(KEY, String(next));
    } catch {
      // Storage is off (private mode): it still works, just isn't remembered.
    }
  };
  return [collapsed, save];
}
